import { CustomerDetails } from 'customer-management/customer-details/customer-details';
import { Redirect } from 'react-router-dom';
import { ROUTES } from 'routing';
import { PERMISSIONS } from 'shared/constants';
import { useUserPermissions } from 'shared/hooks/use-user-permissions';

export function CustomerDetailsResolver() {
  const userPermissions = useUserPermissions();

  if (!userPermissions.includes(PERMISSIONS['customer.view'])) {
    return <Redirect to={ROUTES.unauthorized} />;
  }
  return <CustomerDetails />;
}
